import React from "react";
import { MainContainer, TreeContainer, ErrorText } from './styles';
import { Tree } from 'antd';

export default({ style, checkable, onCheck, checkedKeys, expandedKeys, treeData, error,onExpand }) => {
    return (
        <MainContainer style={style}>
            <TreeContainer error={error}>
                <Tree
                    checkable={checkable}
                    onCheck={onCheck}
                    checkedKeys={checkedKeys}
                    expandedKeys={expandedKeys}
                    treeData={treeData}
                    onExpand={onExpand}
                />
            </TreeContainer>
            {error && <ErrorText>{error}</ErrorText>}
        </MainContainer>
    )
}